/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import useApiRequest from '../../store/slices/hook/useApiRequest';
import Button from '../common/Button';
import Input from '../common/Input';
import { setSelectedBlogs } from '../../store/slices/common';
import { createBlog, updateBlog } from '../../store/slices/api/inner/blogsSlice';
import TextArea from '../common/TextArea';
import Select from '../common/Select';
import { useNavigate } from 'react-router-dom';
import { NAVIGATION } from '../../lib/navigation';
import { fetchBlogType, setBlogTypeData } from '../../store/slices/api/inner/blogTypeSlice';
import TextEditor from '../common/TextEditor';

const BlogsForm = ({
    defaultData,
}) => {
    const dispatch = useDispatch();
    const [blogTypeOptions, setBlogTypeOptions] = useState([]);
    const [file, setFile] = useState(null);
    const [longDescription, setLongDescription] = useState(null);
    const navigate = useNavigate();

    const defaultValues = {
        blogCategoryId: defaultData?.category?.blog_category_id ?? "",
        title: defaultData?.title ?? "",
        shortdescription: defaultData?.short_description ?? "",
    }

    const afterAPICall = (response) => {
        dispatch(setSelectedBlogs(null))
        navigate(NAVIGATION.INNER_NAVIGATION.BLOGS.BLOGS)
    }

    const beforeAPICall = (data) => {
        const formData = new FormData();
        formData.append('blogCategoryId', data?.blogCategoryId ?? "");
        formData.append('title', data?.title ?? "");
        formData.append('shortdescription', data?.shortdescription ?? "");
        formData.append('longDescription', longDescription ?? "");
        if (file) {
            formData.append('thumbnail', file);
        }
        return {
            success: true,
            refactoredData: {
                formData,
                query: {
                    blogId: defaultData?.blog_id ?? "",
                }
            }
        }
    }
    const { isLoading, control, handleSubmit, setValue } = useApiRequest({
        apiAction: defaultData ? updateBlog : createBlog,
        defaultValues,
        clearForm: true,
        beforeAPICall,
        afterAPICall,
    });

    useEffect(() => {
        if (defaultData) {
            setValue('blogCategoryId', defaultData?.category?.blog_category_id ?? "");
            setValue('title', defaultData.title ?? "");
            setValue('shortdescription', defaultData.short_description ?? "");
            setLongDescription(defaultData.long_description ?? "");
        } else {
            setValue('blogCategoryId', "");
            setValue('title', "");
            setValue('shortdescription', "");
            setLongDescription("");
        }
    }, [defaultData, setValue]);

    // fetch start
    const afterFetch = (response) => {
        setBlogTypeOptions(response ? response?.map(blogType => ({ label: blogType?.blog_category_name, value: blogType?.blog_category_id })) : [])
    }
    const { handleSubmit: fetchBlogTypeData } = useApiRequest({
        apiAction: fetchBlogType,
        setValueAction: setBlogTypeData,
        isForm: false,
        successMessage: false,
        afterAPICall: afterFetch,
    });

    useEffect(() => {
        fetchBlogTypeData()
    }, [])
    // fetch end
    return (

        <form onSubmit={handleSubmit} >
            <div className='flex items-center justify-between md:gap-4 flex-col md:flex-row'>
                <Input
                    control={control}
                    name="title"
                    rules={{
                        required: "this field is required"
                    }}
                    label="Title"
                />
                <Input
                    control={control}
                    type='file'
                    name="thumbnail"
                    onChange={(event) => { setFile(event.target.files ? event.target.files[0] : null) }}
                    label="Thumbnail"
                />
                <Select
                    control={control}
                    name="blogCategoryId"
                    rules={{ required: "this field is required" }}
                    options={blogTypeOptions}
                />
            </div>
            <TextArea
                control={control}
                name="shortdescription"
                rules={{ required: "this field is required" }}
                label="Short Description"
            />

            <div className='h-32 mt-6'>
                <TextEditor
                    onChange={setLongDescription}
                    data={longDescription}
                />
            </div>


            <div className="flex justify-end py-6 pt-12">
                <Button isLoading={isLoading}>
                    {defaultData ? "Save changes" : "Submit"}
                </Button>
            </div>
        </form>
    )
}

export default BlogsForm